module.exports = __webpack_public_path__ + "770c6300.png";